import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = `/evaluation`;




export const getAllUserEvaluations = async () => {
  const url = `${API_URL}`;

  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération de toutes les évaluations utilisateurs :', error);
    handleHttpError(error, "Impossible de récupérer toutes les évaluations utilisateurs.");
    throw error;
  }
};



export const saveAutoEvaluation = async (userEvaluation) => {
  const url = `${API_URL}/auto-evaluation`;
  try {
    const response = await api.post(url, userEvaluation);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement de l\'auto évaluation utilisateur :', error);
    handleHttpError(error, "Erreur lors de l'enregistrement de l'évaluation utilisateur.");
    throw error;
  }
};


export const saveEvaluation = async (userEvaluation,idUsers) => {
  const url = `${API_URL}/evaluation`;

  try {
    const response = await api.post(url, userEvaluation,{ params: {idUsers: idUsers },});
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement de l\'évaluation utilisateur :', error);
    handleHttpError(error, "Erreur lors de l'enregistrement de l'évaluation utilisateur.");
    throw error;
  }
};


export const getUserEvaluationsAll = async (page, size, managerId, statuses, year, search,disabled) => {
  const url = `${API_URL}/user-evaluation-all`;

  try {
    const response = await api.get(url, {
      params: { page, size, managerId, statuses, year, search,disabled}
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des évaluations utilisateur :', error);
    handleHttpError(error, "Impossible de récupérer les évaluations utilisateur.");
    throw error;
  }
};

export const getUserEvaluationsReportAll = async (page, size, status, year,disabled, search, idServices,idDirections,idToll) => {
  const url = `${API_URL}/user-evaluation-report-all`;
  const statuses = status.join(',')
  try {
    const response = await api.get(url, {
      params: { page, size, statuses, year, search,disabled,idServices,idDirections,idToll}
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des évaluations utilisateur :', error);
    handleHttpError(error, "Impossible de récupérer les évaluations utilisateur.");
    throw error;
  }
};

export const getUserEvaluationsReportAllToExport = async (page, size, status, year,disabled, search, idServices,idDirections,idToll) => {
  const url = `${API_URL}/user-evaluation-report-all`;
  const statuses = status.join(',')
  try {
    const response = await api.get(url, {
      params: { page, size, statuses, year, search,disabled,idServices,idDirections,idToll}
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des évaluations utilisateur :', error);
    handleHttpError(error, "Impossible de récupérer les évaluations utilisateur.");
    throw error;
  }
};

export const getIdUserEvaluations = async (evaluationsId,usersId) => {
  const url = `${API_URL}/${evaluationsId}/${usersId}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération de l\'évaluation par ID :', error);
    handleHttpError(error, "Impossible de récupérer l'évaluation par ID.");
    throw error;
  }
};

export const getUserEvaluationsByYears = async (usersId,userDataConnectedId, currentYear) => {
  const url = `${API_URL}/years/${usersId}/${userDataConnectedId}/${currentYear}`;

  try {
    const response = await api.get(url);

    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des évaluations par année :', error);
    handleHttpError(error, "Impossible de récupérer les évaluations par année.");
    throw error;
  }
};

export const updateUserEvaluations = async (evaluationsId, userId,save, userEvaluationsData) => {
  const url = `${API_URL}/${evaluationsId}/${userId}/${save}`;
  try {

    const response = await api.put(url, userEvaluationsData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de l\'évaluation utilisateur :', error);
    handleHttpError(error, "Impossible de mettre à jour l'évaluation utilisateur.");
    throw error;
  }
};

export const updateUserEvaluationValid = async (evaluationsId, userId, userEvaluationsData) => {
  const url = `${API_URL}/valid/${evaluationsId}/${userId}`;
  try {
    const response = await api.put(url, userEvaluationsData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de la validation de l\'évaluation :', error);
    handleHttpError(error, "Impossible de valider l'évaluation utilisateur.");
    throw error;
  }
};





export const updateDateEvaluationMeeting = async (evaluationsId, userEvaluationsData, evaluationDateStatus) => {
  const url = `${API_URL}/date_evaluation_meeting/${evaluationsId}/${evaluationDateStatus}`;
  try {
    const response = await api.put(url, userEvaluationsData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de la date de l\'évaluation :', error);
    handleHttpError(error, "Impossible de mettre à jour la date de l'évaluation.");
    throw error;
  }
};


export const updateDateEvaluationStatus =async (evaluationId,userId,userEvaluationData)=> {
  const url = `${API_URL}/update-status/${evaluationId}/${userId}`;
  try {
    const response = await api.put(url, userEvaluationData);
    return response.data;
  }catch (error) {
    handleHttpError(error, "Erreur lors de la modification du statut de l'évalution.");
    throw error;
  }

}
// Fonction pour mettre à jour la décision d'une évaluation utilisateur
export const updateDecisionEvaluation = async (evaluationsId, usersId, userEvaluationsData) => {
  const url = `${API_URL}/decision/${evaluationsId}/${usersId}`;
  try {
    const response = await api.put(url, userEvaluationsData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de la décision de l\'évaluation :', error);
    handleHttpError(error, "Impossible de mettre à jour la décision de l'évaluation.");
    throw error;
  }
};
export const getCountByStatusAndYearsByEvaluation = async (years) => {
  const url = `${API_URL}/dashboard/${years}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération de l'utilisateur.");
    throw error;
  }
};